import { render, staticRenderFns } from "./TabletInfo.vue?vue&type=template&id=70a33137&scoped=true"
import script from "./TabletInfo.vue?vue&type=script&lang=js"
export * from "./TabletInfo.vue?vue&type=script&lang=js"
import style0 from "./TabletInfo.vue?vue&type=style&index=0&id=70a33137&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a33137",
  null
  
)

export default component.exports